import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { DEFAULT_TIMEOUT, TimeoutInterceptor } from './base/interceptors/timeout.interceptor';
import { CmsHttpClient } from './cms/cms-http-client.service';
import { TotaraHttpClient } from './totara/totara-http-client.service';
import { interceptorProviders as totaraInterceptorProviders } from './totara/interceptor-providers';
import { interceptorProviders as cmsInterceptorProviders } from './cms/interceptor-providers';
import { JsonInterceptor } from './base/interceptors/json.interceptor';

export const httpInterceptorProviders = [
  ...totaraInterceptorProviders,
  ...cmsInterceptorProviders,
  { provide: HTTP_INTERCEPTORS, useClass: JsonInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
  { provide: DEFAULT_TIMEOUT, useValue: 120000 }
];

@NgModule({
  imports: [],
  providers: [TotaraHttpClient, CmsHttpClient, httpInterceptorProviders, provideHttpClient(withInterceptorsFromDi())]
})
export class ApiClientsModule {}
